import Resource from 'api/resource';

class UserFieldReportResource extends Resource {
  constructor() {
    super('user-field-report/');
  }
}

export { UserFieldReportResource as default };
